<script setup lang="ts">
import type { Property } from '@/core/entities/property';
import type { SectionName } from '~/types/mixpanel';
import type { H3ClusterId } from '~~/core/ports/repositories';

import { cn } from '@/utils';
import { EventBusKeys } from '~/core/helpers/symbols';

withDefaults(
	defineProps<{
		properties: Property[];
		showCardActions?: boolean;
		section?: SectionName;
	}>(),
	{
		showCardActions: false,
		section: 'listed properties'
	}
);

const propertyCardHover = useEventBus<H3ClusterId[]>(
	EventBusKeys.propertyCardHover
);
const propertyCardUnhover = useEventBus<H3ClusterId[]>(
	EventBusKeys.propertyCardUnhover
);

function handlePropertyCardMouseEnter(property: Property) {
	if (!property.h3ClusterIds?.length) return;

	propertyCardHover.emit(property.h3ClusterIds);
}

function handlePropertyCardMouseLeave(property: Property) {
	if (!property.h3ClusterIds?.length) return;

	propertyCardUnhover.emit(property.h3ClusterIds);
}
</script>

<template>
	<PropertyCard
		v-for="(property, index) in properties"
		:key="property.id"
		variant="whiteBackground"
		:class="
			cn('cursor-pointer h-[340px] md:h-[378px]', {
				'mb-[30px]': index !== 0 && property.poiDistanceTime
			})
		"
		:property="property"
		:section="section"
		:show-actions="showCardActions"
		:card-position="index"
		:as-tags="{
			addresses: 'h3',
			askingPrice: 'h4',
			infoItems: 'h5'
		}"
		@mouseenter="handlePropertyCardMouseEnter(property)"
		@mouseleave="handlePropertyCardMouseLeave(property)"
	/>
</template>
